import axios from "axios";
import { useEffect, useState } from "react";

const useGetImages = (picture, firmaId, categoryId) => {
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!picture || !firmaId || !categoryId) {
      setIsLoading(false);
      return;
    }

    const cacheKey = `img_${picture}_${firmaId}_${categoryId}`;
    
    // Session storage'dan kontrol et
    const cachedImage = sessionStorage.getItem(cacheKey);
    
    if (cachedImage) {
      setImage(cachedImage);
      setIsLoading(false);
      return;
    }

    // Cache yoksa API'den yükle
    (async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/${picture}/${firmaId}/${categoryId}`
        );
        
        const imageData = response?.data;
        setImage(imageData);
        
        // Session storage'a kaydet
        if (imageData) {
          try {
            sessionStorage.setItem(cacheKey, imageData);
          } catch (storageError) {
            // Storage doluysa eski cache'leri temizle
            if (storageError.name === 'QuotaExceededError') {
              const keys = Object.keys(sessionStorage);
              const imageKeys = keys.filter(key => key.startsWith('img_'));
              // İlk yarısını temizle
              imageKeys.slice(0, Math.floor(imageKeys.length / 2)).forEach(key => {
                sessionStorage.removeItem(key);
              });
              // Tekrar dene
              try {
                sessionStorage.setItem(cacheKey, imageData);
              } catch (e) {
                console.warn('Session storage kaydedilemedi:', e);
              }
            }
          }
        }
      } catch (err) {
        setError(err.response);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [picture, firmaId, categoryId]);

  return { image, isLoading, error };
};

export default useGetImages;
